import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FinalModal = ({ isOpen, onClose, completionCount, daysUntilRestart, onRestart }) => {
  if (!isOpen) return null;

  const canRestart = daysUntilRestart <= 0;

  return (
    <AnimatePresence>
      <motion.div
        key="final-modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        style={styles.overlay}
      >
        <motion.div
          key="final-modal-content"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 50, opacity: 0 }}
          transition={{ duration: 0.3 }}
          style={styles.modal}
          onClick={e => e.stopPropagation()}
        >
          <button style={styles.closeButton} onClick={onClose}>
            ✕
          </button>

          {completionCount > 0 && (
            <div style={styles.completionBadge}>
              Прохождение #{completionCount}
            </div>
          )}

          <h1 style={styles.title}>Настройка на ясность проведена.</h1>
          
          <h2 style={styles.subtitle}>
            Используй новые навыки ясности в своих ежедневных историях.
          </h2>
          
          <p style={styles.text}>
            Следующие уровни настройки готовятся. Не теряй фокус.
          </p>

          <p style={styles.restartInfo}>
            {canRestart 
              ? 'Ты можешь пройти настройку заново.'
              : `Настройку на ясность можно повторить через ${daysUntilRestart} дн.`
            }
          </p>

          <div style={styles.buttonsContainer}>
            <a
              href="https://t.me/na_sh_kodila"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.button}
            >
              ТГ канал
            </a>

            <a
              href="https://forms.yandex.ru/u/6940391df47e730d053f8ea6/"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.button}
            >
              Написать отзыв
            </a>

            {canRestart && (
              <button style={styles.restartButton} onClick={onRestart}>
                Начать заново
              </button>
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(10, 10, 10, 0.95)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 3000,
    padding: '20px',
  },
  modal: {
    position: 'relative',
    background: '#1a1a1a',
    borderRadius: '20px',
    maxWidth: '480px',
    width: '100%',
    padding: '40px 30px',
    textAlign: 'center',
    color: '#E5D2A0',
  },
  closeButton: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    width: '32px',
    height: '32px',
    background: 'transparent',
    border: 'none',
    color: 'rgba(229, 210, 160, 0.6)',
    fontSize: '18px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    transition: 'color 0.2s ease',
  },
  completionBadge: {
    display: 'inline-block',
    padding: '6px 14px',
    background: 'rgba(229, 210, 160, 0.15)',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgba(229, 210, 160, 0.3)',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '1px',
    marginBottom: '20px',
    color: '#E5D2A0',
  },
  title: {
    fontSize: '22px',
    fontWeight: '700',
    marginBottom: '12px',
  },
  subtitle: {
    fontSize: '16px',
    fontWeight: '500',
    marginBottom: '24px',
  },
  text: {
    fontSize: '14px',
    marginBottom: '16px',
    color: 'rgba(229, 210, 160, 0.85)',
  },
  restartInfo: {
    fontSize: '13px',
    marginBottom: '28px',
    color: 'rgba(229, 210, 160, 0.6)',
  },
    buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  button: {
    display: 'inline-block',
    padding: '6px 14px',
    background: 'transparent',
    color: '#E5D2A0',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgba(229, 210, 160, 0.3)',
    borderRadius: '20px',
    fontWeight: '400',
    letterSpacing: '0.5px',
    fontSize: '12px',
    textDecoration: 'none',
    textAlign: 'center',
    cursor: 'pointer',
  },
  restartButton: {
    padding: '14px 32px',
    background: '#E5D2A0',
    color: '#0a0a0a',
    border: 'none',
    borderRadius: '30px',
    fontWeight: '600',
    letterSpacing: '1px',
    fontSize: '14px',
    cursor: 'pointer',
  },
};

export default FinalModal;